import type { LibraryNewShareEvent } from '../types/library-notifications';

export const LIBRARY_CONTRACT_LABELS: Record<number, string> = {
  0: 'Passe',
  1: 'Petite',
  2: 'Garde',
  3: 'G. Sans',
  4: 'G. Contre',
};

export function formatLibraryShareToastMessage(data: LibraryNewShareEvent): string {
  const who = data.sharedBy ?? 'Un joueur';
  const contractLabel = data.contract != null
    ? (LIBRARY_CONTRACT_LABELS[data.contract] ?? 'partie')
    : 'partie';

  if (data.isPoll) {
    return `${who} vous a partagé un sondage — ${contractLabel}`;
  }
  if (contractLabel === 'partie' || contractLabel === 'Passe') {
    return `${who} vous a partagé une partie`;
  }
  return `${who} vous a partagé une ${contractLabel}`;
}
